import { render } from "./CadastroFI_Passo_1.vue?vue&type=template&id=de5fbcf6&scoped=true"
import script from "./CadastroFI_Passo_1.vue?vue&type=script&lang=js"
export * from "./CadastroFI_Passo_1.vue?vue&type=script&lang=js"

import "./CadastroFI_Passo_1.vue?vue&type=style&index=0&id=de5fbcf6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de5fbcf6"]])

export default __exports__